<div>
  <form [formGroup]="deductionForm" (ngSubmit)="editNoteAboutUser()">
    <mat-dialog-content>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Комментарий:</mat-label>
        <textarea matInput formControlName="text"> </textarea>
      </mat-form-field>
    </mat-dialog-content>

    <div mat-dialog-actions class="justify-content-end">
      <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
        Отмена
      </button>
      <app-button-with-progress
        typeBtn="submit"
        [loading$]="sendLoading$ | async"
        label="Сохранить"></app-button-with-progress>
    </div>
  </form>
</div>
